module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "提现申请",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "amt"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.amt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amt", $$v)
      },
      expression: "formData.amt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款码",
      "prop": "name"
    }
  }, [_c('label', [_vm._v("支付宝/微信收款码上传\n                    "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImg($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "divEWM"
  }, [_vm._v("支付宝优先处理")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.formData.imgs
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divXFTX"
  }, [_c('span', [_vm._v("友情提醒：根据《中华人民共和国宪法》第56条明确规定，依法纳税是每个公民的基本义务。\n                    本平台对作者的收益没有代扣代缴义务，请作者在平台上获得相应的收益后，自行完成纳税义务，\n                    如有疑问，可咨询当地12366纳税服务热线处理，特此告知!\n                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-tag', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("提现需要收取10%服务费")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46366051"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/user/txEdit.vue
// module id = 1165
// module chunks = 1